<template>
  <div class="each-turn-col">
    <div class="report-alloc-tr benchover-view-turn-wrapper">
      <div
        class="each-turn"
        v-for="(engagement,index) in allocation.benchOverviewEngangements"
        :key="index"
        :class="colorClass(engagement,thresholds)"
      >
        <div class="master-table-text right-table-header alloc-value">
          <p class="right-td">{{engagement.engaged}}%</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BenchTurnover",
  props: ["allocation"],
  computed: {
    thresholds: function() {
      return this.$store.state.reports.metadata;
    }
  },
  methods: {
    colorClass: function(engagement, thresholds) {
      if (engagement.engaged >= thresholds.benchReportGreen) {
        return "blue";
      } else if (
        engagement.engaged >= thresholds.benchReportRed &&
        engagement.engaged < thresholds.benchReportGreen
      ) {
        return "yellow";
      } else {
        return "red";
      }
    }
  }
};
</script>

<style scoped>
.each-turn p {
  padding: 0;
}
</style>
